module.exports = __webpack_public_path__ + "img/images/new-landing/logo.png?a1424407";